export const getReviewsForStorefrontQuery = `
query GetReviewsForVendorByStorefrontId(
  $id: ID!
  $size: Int
  $page: Int
  $sort: Sort!
  $sortType: ReviewsOrderByType!
  $searchText: String
  $stars: [Int!]
  $photos: Boolean
) {
  reviews(
    input: {
      pagination: { page: $page, size: $size }
      filters: { 
        storefrontId: $id,
        searchText: $searchText,
        stars: $stars,
        disputed: false,
        photos: $photos
      }
      orderBy: { type: $sortType, sort: $sort }
    }
  ) {
    nodes {
      userVerified
      highlighted
      attributes {
        weddingDate
      }
      comment {
        active
        commenterId
        content
        createdAt
        id
        updatedAt
      }
      content
      createdAt
      id
      overallRating
      photos {
        active
        sourceId
        createdAt
        updatedAt
        name
        width
        height
      }
      reviewer {
        memberId
        firstName
        lastName
        role
      }
      title
      updatedAt
    }
    totalCount
  }
}
	`;

export type ReviewsForStorefront = {
	reviews: PaginatedReview;
	summaryReviews: SummaryReviews;
	reviewsPhotos: ReviewPhotoPayload;
};

type PaginatedReview = {
	nodes: ReviewNode[];
	totalCount: number;
};

export type ReviewNode = {
	attributes: ReviewAttribute | null;
	comment: ReviewComment | null;
	content: string;
	createdAt: string;
	highlighted: boolean;
	id: string;
	overallRating: number | null;
	photos: ReviewPhoto[];
	reviewer: Reviewer;
	title: string;
	updatedAt: string;
	userVerified: boolean;
};

type ReviewAttribute = {
	weddingDate: string | null;
};

export type ReviewComment = {
	active: boolean;
	commenterId: string;
	content: string;
	createdAt: string;
	id: string;
	updatedAt: string;
};

export type ReviewPhoto = {
	active: boolean;
	createdAt: string;
	height: number | null;
	name: string | null;
	sourceId: string | null;
	updatedAt: string;
	width: number | null;
};

type Reviewer = {
	firstName: string | null;
	lastName: string | null;
	memberId: string | null;
	role: string | null;
};

export type SummaryReviews = {
	count: number;
	distribution: SummaryDistribution;
	rating: number;
	ratings: SummaryRatings;
};

type SummaryDistribution = {
	stars1: number;
	stars2: number;
	stars3: number;
	stars4: number;
	stars5: number;
};

type SummaryRatings = {
	flexibility: number;
	professionalism: number;
	quality: number;
	responseTime: number;
	value: number;
};

type ReviewPhotoPayload = {
	reviewsPhotos: ReviewPhoto[];
};
